import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Typography, MenuItem, Select, Avatar, Tooltip,
} from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import SpaRoundedIcon from '@mui/icons-material/SpaRounded';
import axios from 'axios';
import { useGrowSetup } from '../../GrowSetupContext';

export default function GrowSetupSelect({ collapsed }) {
  const { grow_setup, setGrowSetup } = useGrowSetup();
  const [setups, setSetups] = useState([{ id: 0, name: 'Kein Grow Setup' }]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.post('/get_all_grow_setups', {}).then(res => {
      const data = res.data;
      if (Array.isArray(data) && data.length > 0) {
        setSetups(data);
        const saved = parseInt(localStorage.getItem('grow_setup'), 10);
        if (data.some(s => s.id === saved)) setGrowSetup(saved);
        else setGrowSetup(data[0].id);
      }
    }).catch(console.error);
  }, []);

  if (collapsed) {
    const current = setups.find(s => s.id === grow_setup);
    return (
      <Tooltip title={current?.name || 'Grow Setup'} placement="right">
        <Avatar
          src={current?.avatar || ''}
          sx={{ width: 36, height: 36, mx: 'auto', cursor: 'pointer', border: '2px solid rgba(118,196,66,0.3)' }}
        >
          <SpaRoundedIcon sx={{ fontSize: 18, color: '#76c442' }} />
        </Avatar>
      </Tooltip>
    );
  }

  return (
    <Select
      value={grow_setup || 0}
      onChange={e => {
        if (e.target.value === 'new') { navigate('/grow_setup/new_grow_setup'); return; }
        localStorage.setItem('grow_setup', e.target.value);
        setGrowSetup(e.target.value);
      }}
      fullWidth
      size="small"
      sx={{
        background: 'rgba(118,196,66,0.07)',
        border: '1px solid rgba(118,196,66,0.2)',
        borderRadius: '10px',
        color: 'rgba(255,255,255,0.85)',
        '.MuiOutlinedInput-notchedOutline': { border: 'none' },
        '&:hover': { background: 'rgba(118,196,66,0.12)' },
        '.MuiSelect-select': { py: 1, display: 'flex', alignItems: 'center', gap: 1 },
      }}
    >
      {setups.map(s => (
        <MenuItem key={s.id} value={s.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Avatar src={s.avatar || ''} sx={{ width: 22, height: 22 }}>
            <SpaRoundedIcon sx={{ fontSize: 12 }} />
          </Avatar>
          <Typography variant="body2" noWrap>{s.name}</Typography>
        </MenuItem>
      ))}
      <MenuItem value="new" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Avatar sx={{ width: 22, height: 22, background: 'rgba(118,196,66,0.2)' }}>
          <AddRoundedIcon sx={{ fontSize: 12, color: '#76c442' }} />
        </Avatar>
        <Typography variant="body2" sx={{ color: '#76c442' }}>Neues Setup</Typography>
      </MenuItem>
    </Select>
  );
}
